module.exports = __webpack_public_path__ + "static/img/8.59be3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/8.png
// module id = 3Huu
// module chunks = 1 3